import { DatabaseOutlined, HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const StyledBreadCrumbs = styled(Breadcrumb)`
  margin-bottom: 12px;

  li:last-child .ant-breadcrumb-link {
    text-decoration: none;
  }

  .ant-breadcrumb-link {
    transition: color 0.1s ease-out;
    text-decoration: underline;

    .anticon {
      margin-right: 6px;
    }

    &:hover {
      cursor: pointer;
      color: ${(props) => props.theme.colors.brandOrange};
    }
  }
`;

const BreadCrumbs = () => {
  const location = useLocation();
  const navigation = useHistory();

  const getBreadcrumbItems = () => {
    const pathname = location.pathname;
    const items = [
      {
        key: 'overview',
        title: (
          <span
            onClick={() => {
              navigation.replace('/overview');
            }}
          >
            <HomeOutlined />
            <span>Overview</span>
          </span>
        ),
      },
    ];

    if (pathname === '/case-types') {
      items.push({
        key: 'case-types',
        title: (
          <span
            onClick={() => {
              navigation.replace('/case-types');
            }}
          >
            <DatabaseOutlined />
            <span>Casetypes</span>
          </span>
        ),
      });
    } else if (pathname === '/pcodes') {
      items.push({
        key: 'pcodes',
        title: (
          <span
            onClick={() => {
              navigation.replace('/pcodes');
            }}
          >
            <DatabaseOutlined />
            <span>Pcodes</span>
          </span>
        ),
      });
    }

    return items;
  };

  return <StyledBreadCrumbs items={getBreadcrumbItems()} />;
};

export default BreadCrumbs;
